import { createUseStyles } from 'react-jss'
import { transitionShort, zIndex8 } from '../../../styles/const/common'
import { darkGrey, mediumGrey } from '../../../styles/const/colors'
import { smallDesktopDown } from '../../../styles/const/breakpoints'

export default createUseStyles(theme => ({
  dropdownWrapper: {
    pointerEvents: options => (options ? 'auto' : 'none'),
    position: 'relative'
  },
  actionsBtn: {
    border: 0,
    padding: '2px 9px',
    display: 'flex',
    alignItems: 'center',
    outline: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    visibility: options => (options ? 'initial' : 'hidden'),
    '& svg path': {
      fill: mediumGrey,
      transition: transitionShort
    },
    '&:hover svg path': {
      fill: theme.brandPrimary
    }
  },
  dropdown: {
    zIndex: zIndex8
  },
  actionsList: {
    margin: 0,
    padding: 0,
    listStyle: 'none'
  },
  actionsItem: {
    display: 'block',
    color: darkGrey,
    padding: '5px 11px',
    fontSize: 14,
    transition: transitionShort,
    '&:hover': {
      backgroundColor: theme.brandPrimaryLight,
      cursor: 'pointer'
    }
  },
  actionsLink: {
    textDecoration: 'none',
    color: darkGrey
  },

  [`@media screen and (${smallDesktopDown})`]: {
    actionsBtn: {
      order: 1
    }
  }
}))
